import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import * as TextConstants from '../../constants/text.constants';

@Component({
  selector: 'fd-calendar',
  templateUrl: './fd-calendar.component.html',
  styleUrls: ['./fd-calendar.component.scss'],
})
export class FdCalendarComponent implements AfterViewInit {
  textConstants = TextConstants;

  @Input() isRange: boolean = false;
  @Input() selectedDate: Date | null = null;
  @Output() selectedDateChange = new EventEmitter<Date | null>();

  @Output() rangeSelect = new EventEmitter<{
    startDate: string | null | undefined;
    endDate: string | null | undefined;
  }>();

  ngAfterViewInit(): void {
    this.setSeparatorWhenHidden();
  }

  emitRange(startInput: HTMLInputElement, endInput: HTMLInputElement) {
    this.rangeSelect.emit({
      startDate: startInput.value,
      endDate: endInput.value,
    });
  }

  emitSingleDate(dateInput: HTMLInputElement) {
    const localDate = new Date(dateInput.value);

    if (isNaN(localDate.getTime())) {
      this.selectedDateChange.emit(null);
      return;
    }

    const utcDate = new Date(
      Date.UTC(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate()
      )
    );

    this.selectedDateChange.emit(utcDate);
  }

  private setSeparatorWhenHidden(): void {
    const spanElement = document.querySelector(
      '.mat-date-range-input-separator-hidden'
    );
    if (spanElement) {
      spanElement.textContent = '-';
    }
  }
}
